import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../https.service';
import { URLUtils } from '../urlUtils';

/**
 * Lawyer history (LexiZ lawyer detail screen).
 *
 * Every endpoint lives on the admin API, so all calls go through the
 * `sendRe*` side of HttpService. Those methods take the query string already
 * interpolated, so params are built and encoded here.
 */
@Injectable({
  providedIn: 'root'
})
export class LawyerHistoryService {

  constructor(private httpService: HttpService) {}

  private toQuery(params: any): string {
    if (!params) {
      return '';
    }

    const parts: string[] = [];

    Object.keys(params).forEach(key => {
      const value = params[key];

      if (value !== null && value !== undefined && value !== '') {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    });

    return parts.length ? `?${parts.join('&')}` : '';
  }

  getSummary(lawyerId: string): Observable<any> {
    return this.httpService.sendReGetRequest(
      URLUtils.lawyerHistorySummary(lawyerId)
    ) as Observable<any>;
  }

  getAppointments(lawyerId: string, params?: any): Observable<any> {
    return this.httpService.sendReGetRequest(
      URLUtils.lawyerHistoryAppointments(lawyerId) + this.toQuery(params)
    ) as Observable<any>;
  }

  getAppointmentDetail(lawyerId: string, appointmentId: string): Observable<any> {
    return this.httpService.sendReGetRequest(
      URLUtils.lawyerHistoryAppointmentDetail(lawyerId, appointmentId)
    ) as Observable<any>;
  }

  getSettlements(lawyerId: string, params?: any): Observable<any> {
    return this.httpService.sendReGetRequest(
      URLUtils.lawyerHistorySettlements(lawyerId) + this.toQuery(params)
    ) as Observable<any>;
  }

  // Takes our payout id; the razorpay payout id is accepted too.
  getSettlementDetail(lawyerId: string, payoutId: string): Observable<any> {
    return this.httpService.sendReGetRequest(
      URLUtils.lawyerHistorySettlementDetail(lawyerId, payoutId)
    ) as Observable<any>;
  }

  getEarnings(lawyerId: string, params?: any): Observable<any> {
    return this.httpService.sendReGetRequest(
      URLUtils.lawyerHistoryEarnings(lawyerId) + this.toQuery(params)
    ) as Observable<any>;
  }

  getActivity(lawyerId: string, params?: any): Observable<any> {
    return this.httpService.sendReGetRequest(
      URLUtils.lawyerHistoryActivity(lawyerId) + this.toQuery(params)
    ) as Observable<any>;
  }
}
